module.exports = __webpack_public_path__ + "assets/pdf/torrontes.10c263a3.pdf";